import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
// import storage from 'redux-persist/lib/storage'
import storage  from 'redux-persist/lib/storage/session';
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import rootReducer from '../reducers'

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'app', 'user', 'account', 'biller', 'offer'],
  //whitelist: ['styles'],
}

const persistedReducer = persistReducer(rootPersistConfig, rootReducer)

const store = createStore(persistedReducer, {}, composeWithDevTools(applyMiddleware(thunk)))

const persistor = persistStore(store)

export { store, persistor }
